import { CustomerLead } from '../domain/customerLead.model'
import apiClient from '../infraestructure/apiClient'
import { getOfferDocumentId } from '../services/storage.service'

export default {
  putCustomer: function(customer: CustomerLead) {
    return apiClient.put<CustomerLeadResponseDTO>(
      `/offerDocument/${getOfferDocumentId()}/customerLead`,
      customer,
    )
  },
  contactMe: function() {
    return apiClient.post(`/offerDocument/${getOfferDocumentId()}/contactMe`)
  },
}

interface CustomerLeadResponseDTO {
  data: CustomerLead
  error?: {
    description: string
    errorCode: number
  }
  status: string
}
